import { render, staticRenderFns } from "./setThePassword.vue?vue&type=template&id=59c2c76e&scoped=true&"
import script from "./setThePassword.vue?vue&type=script&lang=js&"
export * from "./setThePassword.vue?vue&type=script&lang=js&"
import style0 from "./setThePassword.vue?vue&type=style&index=0&id=59c2c76e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c2c76e",
  null
  
)

export default component.exports